import { FC } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { UserModel } from '../../../../app/modules/auth/models/UserModel'
import { RootState } from '../../../../setup'
import { Languages } from './Languages'
import * as auth from '../../../../app/modules/auth/redux/actions'
import { useDispatch } from 'react-redux'
import { toAbsoluteUrl } from '../../../helpers'
import axios from 'axios'
import { toast } from 'react-toastify'
import AuthService from 'src/cms/constants/authService'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export const LOGOUT_MODEL = `${API_URL}/logout`

const HeaderUserMenu: FC = () => {
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const { name, email } = user?.data
  const dispatch = useDispatch()
  const authService = new AuthService()


  const logout = () => {
    axios
      .get(LOGOUT_MODEL)
      .then((response) => {
        toast.success('Logout successfully')
        // authService.logout()
        dispatch(auth.actions.logout())
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <div className='profileImage'>
              <span>{name.split(' ').map((word) => word[0])}</span>
            </div>
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{name}</div>
            <a href='#' className='fw-bold text-muted text-hover-primary fs-7'>
              {email}
            </a>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
